import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect';

import { Section } from 'components';
import {
  CompanyEmail, CompanyPhone,
} from 'variables';
import { LineBreak } from './style';

declare const window: any;

const ContactSection: React.FC = _ => {
  useEffect(() => {
    window.Kakao.init("e069d65fab0988bf5c14f8f243abd9f8");

    return () => {
      window.Kakao.cleanup();
    }
  }, []);

  const openPlusFriend = () => {
    window.Kakao.PlusFrend.chat({
      plusFriendId: '_PXqRM',
    });
  }

  return (
    <Section minHeight={300} mobileMinHeight={450}>
      <h1>제휴 문의</h1>
      <p>언제든 친절하게 상담해드립니다. <LineBreak/>부담없이 문의하세요 :)</p>
        <div style={{
          marginTop: '30px',
        }} className="button-groups">
          <a style={{
            display: 'flex',
            flexDirection: 'column',
            minWidth: '250px',
            fontSize: '18px',
          }} href={`tel:${CompanyPhone.replace(/-/g, '')}`}>
            전화번호<br/>
            {CompanyPhone}
          </a>
          <a style={{
            display: 'flex',
            flexDirection: 'column',
            minWidth: '250px',
            fontSize: '18px',
          }} href={`mailto:${CompanyEmail}`}>
            이메일<br/>
            {CompanyEmail}
          </a>
          {
            isMobile ? (
              // eslint-disable-next-line
              <a style={{
                display: 'flex',
                flexDirection: 'column',
                minWidth: '250px',
                fontSize: '18px',
              }}
                onClick={() => openPlusFriend()}
              >
                카카오톡<br/>@데이트팝
              </a>
            ) : (
              <a style={{
                display: 'flex',
                flexDirection: 'column',
                minWidth: '250px',
                fontSize: '18px',
              }}
                href="http://plus.kakao.com/home/keegmyz7"
                target="_blank"
                rel="noopener noreferrer"
              >
                카카오톡<br/>@데이트팝
              </a>
            )
          }
        </div>
    </Section>
  );
}

export default ContactSection;
